import {Injectable} from "@angular/core";
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {catchError, Observable, throwError} from "rxjs";

export const headerAvoidInterceptor = 'X-Avoid-Interceptor';

export class HttpInterceptorError extends Error {
  constructor(
    message: string,
    public readonly httpError: HttpErrorResponse
  ) {
    super(message);
    this.name = 'Error';
    if (httpError.error instanceof Error) {
      this.stack = httpError.error.stack;
    }
  }

  get status(): number {
    return this.httpError.status;
  }

  get statusText(): string {
    return this.httpError.statusText;
  }
}

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.has(headerAvoidInterceptor)) {
      const headers = req.headers.delete(headerAvoidInterceptor);
      return next.handle(req.clone({headers}));
    }

    return next.handle(req).pipe(
      catchError((e: HttpErrorResponse) => {
        const msgByMethodType = this.getMethodType(req);
        const userMessage = `Falha ao ${msgByMethodType} os dados ao serviço remoto.`;

        const error = new HttpInterceptorError(userMessage, e);

        return throwError(() => error);
      })
    );
  }

  private getMethodType(req: HttpRequest<any>): string {
    switch (req.method) {
      case 'GET':
        return 'obter';
      case 'DELETE':
        return 'excluir';
      default:
        return 'enviar';
    }
  }
}

